import React, { useEffect } from 'react';
import { func, string, shape, bool } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteFooter } from '@tesla/tw-react';
import { GlobalMenu, Loader } from '@tesla/design-system-react';

import Content from './pages';
import Selectors from './selectors';
import * as Actions from './actions';

import '@tesla/design-system/dist/index.css';
import './css/reset.css';
import '@tesla/tw-react/dist/index.css';

import styles from './App.module.css';
import useHideHeaderAndFooter from './hooks/useHideHeaderAndFooter';

const propTypes = {
  baseRoute: string.isRequired,
  isCNEnv: bool.isRequired,
  locale: string.isRequired,
  localeCountry: string.isRequired,
  setInitialCountry: func.isRequired,
  setInitialData: func.isRequired,
  showLoader: bool.isRequired,
  solutionsData: shape({}).isRequired,
  header: shape({
    enabled: bool,
    endpoint: string,
    locale: string,
  }).isRequired,
};

const App = ({
  baseRoute,
  isCNEnv,
  locale,
  localeCountry,
  setInitialCountry,
  setInitialData,
  showLoader,
  solutionsData,
  header,
}) => {
  useEffect(() => {
    setInitialData({ solutionsData });
    setInitialCountry({ localeCountry });
  }, []);
  const hideFooterAndHeader = useHideHeaderAndFooter();
  return (
    <>
      {!hideFooterAndHeader && isCNEnv && (
        <GlobalMenu endpoint={header.endpoint} locale={header.locale} />
      )}
      <div className={styles.AppWrapper}>
        <BrowserRouter basename={baseRoute}>
          <Loader fullscreen show={showLoader} />
          <div id="main-content" className={styles.AppWrapper}>
            <Content />
          </div>
        </BrowserRouter>
      </div>
      {!hideFooterAndHeader && <SiteFooter locale={locale} />}
    </>
  );
};
App.propTypes = propTypes;

export default connect(
  Selectors,
  Actions
)(App);
